import { AbstractControl } from '@angular/forms';

const PHONE_REGEXP = new RegExp(/^[2-9]\d{9}/);

export function validatePhone(control: AbstractControl) {

	if (!control.value) {
		return null;  // don't validate empty values to allow optional controls
	}

	const validity = { validPhone: true };

	const textVal = control.value;

	const isValid = PHONE_REGEXP.test(textVal);

	if (!isValid) {
		validity.validPhone = false;
		return validity;
	}

	if (control.value.length >= 3 && textVal.charAt(1) === '1' && textVal.charAt(2) === '1') {
		return validity;
	}

	return null;
}
